export const settings = {
  en: {
    title: 'Settings',
    subtitle: 'Customize your Bible quiz experience',
    account: 'Account',
    notifications: 'Notifications',
    sound: 'Sound',
    darkMode: 'Dark Mode',
    language: 'Language',
    fontSize: 'Font Size',
    decreaseFont: 'Decrease font size',
    increaseFont: 'Increase font size',
    help: 'Help',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    about: 'About',
    subscription: 'Subscription',
    premium: 'Premium',
    managePremium: 'View plans and manage your subscription',
    signOut: 'Sign Out',
    signingOut: 'Signing out...',
    signOutFailed: 'Sign out failed',
    endSession: 'End your current session',
    // Account Management
    accountManagement: 'Account',
    resetPasswordTitle: 'Reset Password',
    resetPasswordDetail: 'Send a reset link to your email',
    resetPasswordMessage: "We'll send a password reset link to {email}",
    sendResetLink: 'Send Reset Link',
    resetPasswordSent: 'Email Sent',
    resetPasswordSentMessage: 'Check your inbox at {email} for a password reset link.',
    resetPasswordFailed: 'Failed to send reset email. Please try again.',
    oauthNoPassword: 'You signed in with {provider}. No password to reset — just sign in with your {provider} account.',
    signedInWith: 'Signed in with {provider}',
    noEmailFound: 'No email address found for this account.',
    error: 'Error',
    deletingAccount: 'Deleting...',
    deleteConfirmTitle: 'Are you sure?',
    deleteConfirmMessage: 'Your {provider} account ({email}) and all quiz data will be permanently deleted.',
    deleteConfirmButton: 'Yes, Delete Everything',
    reAuthRequired: 'Verify Identity',
    reAuthMessage: 'Please sign out and sign back in, then try again.',
    adminLocalization: 'Admin: Localization',
    // Guest User Messages
    notSignedIn: 'Not Signed In',
    guestNoAccount: 'You are playing as a guest. Sign in to create an account and save your progress.',
    ok: 'OK',
    pgsTitle: 'Play Games',
    pgsConnect: 'Connect Play Games',
    pgsConnecting: 'Connecting...',
    pgsAchievements: 'Play Games Achievements',
    pgsConnectFailed: 'Could not connect to Play Games. Please try again.',
    pgsConnectSuccess: 'Successfully connected to Google Play Games!',
    pgsLinkFailed: 'Failed to link account. Please try again.',
    pgsError: 'An error occurred. Please try again.',
  },
  es: {
    title: 'Configuración',
    subtitle: 'Personaliza tu experiencia de cuestionario bíblico',
    account: 'Cuenta',
    notifications: 'Notificaciones',
    sound: 'Sonido',
    darkMode: 'Modo oscuro',
    language: 'Idioma',
    fontSize: 'Tamaño de fuente',
    decreaseFont: 'Disminuir tamaño de fuente',
    increaseFont: 'Aumentar tamaño de fuente',
    help: 'Ayuda',
    privacyPolicy: 'Política de privacidad',
    termsOfService: 'Términos de servicio',
    about: 'Acerca de',
    subscription: 'Suscripción',
    premium: 'Premium',
    managePremium: 'Ver planes y administrar tu suscripción',
    signOut: 'Cerrar sesión',
    signingOut: 'Cerrando sesión...',
    signOutFailed: 'Error al cerrar sesión',
    endSession: 'Finalizar la sesión actual',
    // Account Management
    accountManagement: 'Cuenta',
    resetPasswordTitle: 'Restablecer contraseña',
    resetPasswordDetail: 'Enviar un enlace de restablecimiento a tu correo',
    resetPasswordMessage: 'Te enviaremos un enlace para restablecer tu contraseña a {email}',
    sendResetLink: 'Enviar enlace de restablecimiento',
    resetPasswordSent: 'Correo enviado',
    resetPasswordSentMessage: 'Revisa tu bandeja de entrada en {email} para el enlace de restablecimiento de contraseña.',
    resetPasswordFailed: 'Error al enviar el correo de restablecimiento. Inténtalo de nuevo.',
    oauthNoPassword: 'Iniciaste sesión con {provider}. No hay contraseña que restablecer — simplemente inicia sesión con tu cuenta de {provider}.',
    signedInWith: 'Sesión iniciada con {provider}',
    noEmailFound: 'No se encontró una dirección de correo para esta cuenta.',
    error: 'Error',
    deletingAccount: 'Eliminando...',
    deleteConfirmTitle: '¿Estás seguro?',
    deleteConfirmMessage: 'Tu cuenta de {provider} ({email}) y todos los datos del cuestionario se eliminarán permanentemente.',
    deleteConfirmButton: 'Sí, eliminar todo',
    reAuthRequired: 'Verificar identidad',
    reAuthMessage: 'Cierra sesión y vuelve a iniciar sesión, luego inténtalo de nuevo.',
    adminLocalization: 'Admin: Localización',
    // Guest User Messages
    notSignedIn: 'No has iniciado sesión',
    guestNoAccount: 'Estás jugando como invitado. Inicia sesión para crear una cuenta y guardar tu progreso.',
    ok: 'OK',
    pgsTitle: 'Play Games',
    pgsConnect: 'Conectar Play Games',
    pgsConnecting: 'Conectando...',
    pgsAchievements: 'Logros de Play Games',
    pgsConnectFailed: 'No se pudo conectar con Play Games. Inténtalo de nuevo.',
    pgsConnectSuccess: 'Conexión con Google Play Games completada correctamente.',
    pgsLinkFailed: 'No se pudo vincular la cuenta. Inténtalo de nuevo.',
    pgsError: 'Ocurrió un error. Inténtalo de nuevo.',
  },
  fr: {
    title: 'Paramètres',
    subtitle: 'Personnalisez votre expérience de quiz biblique',
    account: 'Compte',
    notifications: 'Notifications',
    sound: 'Son',
    darkMode: 'Mode sombre',
    language: 'Langue',
    fontSize: 'Taille de police',
    decreaseFont: 'Diminuer la taille de police',
    increaseFont: 'Augmenter la taille de police',
    help: 'Aide',
    privacyPolicy: 'Politique de confidentialité',
    termsOfService: 'Conditions de service',
    about: 'À propos',
    subscription: 'Abonnement',
    premium: 'Premium',
    managePremium: 'Voir les forfaits et gérer votre abonnement',
    signOut: 'Se déconnecter',
    signingOut: 'Déconnexion en cours...',
    endSession: 'Terminer votre session en cours',
    signOutFailed: 'Échec de la déconnexion',
    // Account Management
    accountManagement: 'Compte',
    resetPasswordTitle: 'Réinitialiser le mot de passe',
    resetPasswordDetail: 'Envoyer un lien de réinitialisation à votre e-mail',
    resetPasswordMessage: 'Nous enverrons un lien de réinitialisation du mot de passe à {email}',
    sendResetLink: 'Envoyer le lien de réinitialisation',
    resetPasswordSent: 'E-mail envoyé',
    resetPasswordSentMessage: 'Vérifiez votre boîte de réception à {email} pour le lien de réinitialisation du mot de passe.',
    resetPasswordFailed: 'Échec de l\'envoi de l\'e-mail de réinitialisation. Veuillez réessayer.',
    oauthNoPassword: 'Vous vous êtes connecté avec {provider}. Pas de mot de passe à réinitialiser — connectez-vous simplement avec votre compte {provider}.',
    signedInWith: 'Connecté avec {provider}',
    noEmailFound: 'Aucune adresse e-mail trouvée pour ce compte.',
    error: 'Erreur',
    deletingAccount: 'Suppression...',
    deleteConfirmTitle: 'Êtes-vous sûr ?',
    deleteConfirmMessage: 'Votre compte {provider} ({email}) et toutes les données du quiz seront définitivement supprimés.',
    deleteConfirmButton: 'Oui, tout supprimer',
    reAuthRequired: 'Vérifier l\'identité',
    reAuthMessage: 'Veuillez vous déconnecter et vous reconnecter, puis réessayez.',
    adminLocalization: 'Admin: Localisation',
    // Guest User Messages
    notSignedIn: 'Non connecté',
    guestNoAccount: 'Vous jouez en tant qu\'invité. Connectez-vous pour créer un compte et sauvegarder votre progression.',
    ok: 'OK',
    pgsTitle: 'Play Games',
    pgsConnect: 'Connecter Play Games',
    pgsConnecting: 'Connexion...',
    pgsAchievements: 'Succès Play Games',
    pgsConnectFailed: 'Impossible de se connecter à Play Games. Veuillez réessayer.',
    pgsConnectSuccess: 'Connexion à Google Play Games réussie.',
    pgsLinkFailed: 'Échec de la liaison du compte. Veuillez réessayer.',
    pgsError: 'Une erreur est survenue. Veuillez réessayer.',
  },
  de: {
    title: 'Einstellungen',
    subtitle: 'Passen Sie Ihr Bibel-Quiz-Erlebnis an',
    account: 'Konto',
    notifications: 'Benachrichtigungen',
    sound: 'Ton',
    darkMode: 'Dunkler Modus',
    language: 'Sprache',
    fontSize: 'Schriftgröße',
    decreaseFont: 'Schriftgröße verringern',
    increaseFont: 'Schriftgröße erhöhen',
    help: 'Hilfe',
    privacyPolicy: 'Datenschutzrichtlinie',
    termsOfService: 'Nutzungsbedingungen',
    about: 'Über',
    subscription: 'Abonnement',
    premium: 'Premium',
    managePremium: 'Tarife ansehen und Ihr Abonnement verwalten',
    signOut: 'Abmelden',
    signingOut: 'Abmeldung läuft...',
    endSession: 'Aktuelle Sitzung beenden',
    signOutFailed: 'Abmeldung fehlgeschlagen',
    // Account Management
    accountManagement: 'Konto',
    resetPasswordTitle: 'Passwort zurücksetzen',
    resetPasswordDetail: 'Einen Rücksetzungslink an Ihre E-Mail senden',
    resetPasswordMessage: 'Wir senden einen Link zum Zurücksetzen des Passworts an {email}',
    sendResetLink: 'Rücksetzungslink senden',
    resetPasswordSent: 'E-Mail gesendet',
    resetPasswordSentMessage: 'Überprüfen Sie Ihren Posteingang unter {email} auf den Link zum Zurücksetzen des Passworts.',
    resetPasswordFailed: 'Fehler beim Senden der Rücksetzungs-E-Mail. Bitte versuchen Sie es erneut.',
    oauthNoPassword: 'Sie haben sich mit {provider} angemeldet. Kein Passwort zum Zurücksetzen — melden Sie sich einfach mit Ihrem {provider}-Konto an.',
    signedInWith: 'Angemeldet mit {provider}',
    noEmailFound: 'Keine E-Mail-Adresse für dieses Konto gefunden.',
    error: 'Fehler',
    deletingAccount: 'Wird gelöscht...',
    deleteConfirmTitle: 'Sind Sie sicher?',
    deleteConfirmMessage: 'Ihr {provider}-Konto ({email}) und alle Quizdaten werden dauerhaft gelöscht.',
    deleteConfirmButton: 'Ja, alles löschen',
    reAuthRequired: 'Identität bestätigen',
    reAuthMessage: 'Bitte melden Sie sich ab und wieder an und versuchen Sie es dann erneut.',
    adminLocalization: 'Admin: Lokalisierung',
    // Guest User Messages
    notSignedIn: 'Nicht angemeldet',
    guestNoAccount: 'Sie spielen als Gast. Melden Sie sich an, um ein Konto zu erstellen und Ihren Fortschritt zu speichern.',
    ok: 'OK',
    pgsTitle: 'Play Games',
    pgsConnect: 'Play Games verbinden',
    pgsConnecting: 'Verbinden...',
    pgsAchievements: 'Play Games-Erfolge',
    pgsConnectFailed: 'Verbindung zu Play Games konnte nicht hergestellt werden. Bitte versuchen Sie es erneut.',
    pgsConnectSuccess: 'Erfolgreich mit Google Play Games verbunden.',
    pgsLinkFailed: 'Konto konnte nicht verknüpft werden. Bitte versuchen Sie es erneut.',
    pgsError: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
  },
  pt: {
    title: 'Configurações',
    subtitle: 'Personalize sua experiência de quiz bíblico',
    account: 'Conta',
    notifications: 'Notificações',
    sound: 'Som',
    darkMode: 'Modo escuro',
    language: 'Idioma',
    fontSize: 'Tamanho da fonte',
    decreaseFont: 'Diminuir tamanho da fonte',
    increaseFont: 'Aumentar tamanho da fonte',
    help: 'Ajuda',
    privacyPolicy: 'Política de privacidade',
    termsOfService: 'Termos de serviço',
    about: 'Sobre',
    subscription: 'Assinatura',
    premium: 'Premium',
    managePremium: 'Ver planos e gerenciar sua assinatura',
    signOut: 'Sair',
    signingOut: 'Saindo...',
    endSession: 'Encerrar sua sessão atual',
    signOutFailed: 'Falha ao sair',
    // Account Management
    accountManagement: 'Conta',
    resetPasswordTitle: 'Redefinir senha',
    resetPasswordDetail: 'Enviar um link de redefinição para seu e-mail',
    resetPasswordMessage: 'Enviaremos um link de redefinição de senha para {email}',
    sendResetLink: 'Enviar link de redefinição',
    resetPasswordSent: 'E-mail enviado',
    resetPasswordSentMessage: 'Verifique sua caixa de entrada em {email} para o link de redefinição de senha.',
    resetPasswordFailed: 'Falha ao enviar o e-mail de redefinição. Tente novamente.',
    oauthNoPassword: 'Você entrou com {provider}. Não há senha para redefinir — basta entrar com sua conta {provider}.',
    signedInWith: 'Conectado com {provider}',
    noEmailFound: 'Nenhum endereço de e-mail encontrado para esta conta.',
    error: 'Erro',
    deletingAccount: 'Excluindo...',
    deleteConfirmTitle: 'Tem certeza?',
    deleteConfirmMessage: 'Sua conta {provider} ({email}) e todos os dados do quiz serão excluídos permanentemente.',
    deleteConfirmButton: 'Sim, excluir tudo',
    reAuthRequired: 'Verificar identidade',
    reAuthMessage: 'Saia e entre novamente, depois tente outra vez.',
    adminLocalization: 'Admin: Localização',
    // Guest User Messages
    notSignedIn: 'Não conectado',
    guestNoAccount: 'Você está jogando como convidado. Entre para criar uma conta e salvar seu progresso.',
    ok: 'OK',
    pgsTitle: 'Play Games',
    pgsConnect: 'Conectar Play Games',
    pgsConnecting: 'Conectando...',
    pgsAchievements: 'Conquistas do Play Games',
    pgsConnectFailed: 'Não foi possível conectar ao Play Games. Tente novamente.',
    pgsConnectSuccess: 'Conectado ao Google Play Games com sucesso.',
    pgsLinkFailed: 'Falha ao vincular a conta. Tente novamente.',
    pgsError: 'Ocorreu um erro. Tente novamente.',
  },
  ru: {
    title: 'Настройки',
    subtitle: 'Настройте ваш библейский квиз',
    account: 'Аккаунт',
    notifications: 'Уведомления',
    sound: 'Звук',
    darkMode: 'Темный режим',
    language: 'Язык',
    fontSize: 'Размер шрифта',
    decreaseFont: 'Уменьшить размер шрифта',
    increaseFont: 'Увеличить размер шрифта',
    help: 'Помощь',
    privacyPolicy: 'Политика конфиденциальности',
    termsOfService: 'Условия использования',
    about: 'О приложении',
    subscription: 'Подписка',
    premium: 'Премиум',
    managePremium: 'Просмотр тарифов и управление подпиской',
    signOut: 'Выйти',
    signingOut: 'Выход из системы...',
    endSession: 'Завершить текущую сессию',
    signOutFailed: 'Ошибка выхода',
    // Account Management
    accountManagement: 'Аккаунт',
    resetPasswordTitle: 'Сбросить пароль',
    resetPasswordDetail: 'Отправить ссылку для сброса на вашу почту',
    resetPasswordMessage: 'Мы отправим ссылку для сброса пароля на {email}',
    sendResetLink: 'Отправить ссылку для сброса',
    resetPasswordSent: 'Письмо отправлено',
    resetPasswordSentMessage: 'Проверьте входящие на {email} — там будет ссылка для сброса пароля.',
    resetPasswordFailed: 'Не удалось отправить письмо для сброса. Попробуйте снова.',
    oauthNoPassword: 'Вы вошли через {provider}. Пароль сбрасывать не нужно — просто войдите через свой аккаунт {provider}.',
    signedInWith: 'Вход через {provider}',
    noEmailFound: 'Для этого аккаунта не найден адрес электронной почты.',
    error: 'Ошибка',
    deletingAccount: 'Удаление...',
    deleteConfirmTitle: 'Вы уверены?',
    deleteConfirmMessage: 'Ваш аккаунт {provider} ({email}) и все данные викторин будут удалены навсегда.',
    deleteConfirmButton: 'Да, удалить всё',
    reAuthRequired: 'Подтвердите личность',
    reAuthMessage: 'Пожалуйста, выйдите и войдите снова, затем повторите попытку.',
    adminLocalization: 'Админ: Локализация',
    // Guest User Messages
    notSignedIn: 'Не вошли в систему',
    guestNoAccount: 'Вы играете как гость. Войдите, чтобы создать аккаунт и сохранить свой прогресс.',
    ok: 'ОК',
    pgsTitle: 'Play Games',
    pgsConnect: 'Подключить Play Games',
    pgsConnecting: 'Подключение...',
    pgsAchievements: 'Достижения Play Games',
    pgsConnectFailed: 'Не удалось подключиться к Play Games. Попробуйте снова.',
    pgsConnectSuccess: 'Подключение к Google Play Games выполнено успешно.',
    pgsLinkFailed: 'Не удалось связать аккаунт. Попробуйте снова.',
    pgsError: 'Произошла ошибка. Попробуйте снова.',
  },
  tl: {
    title: 'Mga Setting',
    subtitle: 'I-customize ang inyong Bible quiz na karanasan',
    account: 'Account',
    notifications: 'Mga Notification',
    sound: 'Tunog',
    darkMode: 'Dark Mode',
    language: 'Wika',
    fontSize: 'Laki ng Font',
    decreaseFont: 'Paliitin ang font',
    increaseFont: 'Palakihin ang font',
    help: 'Tulong',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    about: 'Tungkol',
    subscription: 'Subskripsyon',
    premium: 'Premium',
    managePremium: 'Tingnan ang mga plano at pamahalaan ang iyong subskripsyon',
    signOut: 'Mag-logout',
    signingOut: 'Nagla-logout...',
    endSession: 'Tapusin ang kasalukuyang session',
    signOutFailed: 'Hindi naka-logout',
    // Account Management
    accountManagement: 'Account',
    resetPasswordTitle: 'I-reset ang Password',
    resetPasswordDetail: 'Magpadala ng reset link sa iyong email',
    resetPasswordMessage: 'Magpapadala kami ng link para i-reset ang password sa {email}',
    sendResetLink: 'Ipadala ang Reset Link',
    resetPasswordSent: 'Naipadala na ang Email',
    resetPasswordSentMessage: 'Tingnan ang iyong inbox sa {email} para sa link ng pag-reset ng password.',
    resetPasswordFailed: 'Hindi naipadala ang reset email. Pakisubukan muli.',
    oauthNoPassword: 'Nag-sign in ka gamit ang {provider}. Walang password na ire-reset — mag-sign in lang gamit ang iyong {provider} account.',
    signedInWith: 'Naka-sign in gamit ang {provider}',
    noEmailFound: 'Walang nahanap na email address para sa account na ito.',
    error: 'Error',
    deletingAccount: 'Dine-delete...',
    deleteConfirmTitle: 'Sigurado ka ba?',
    deleteConfirmMessage: 'Ang iyong {provider} account ({email}) at lahat ng quiz data ay permanenteng made-delete.',
    deleteConfirmButton: 'Oo, I-delete Lahat',
    reAuthRequired: 'I-verify ang Pagkakakilanlan',
    reAuthMessage: 'Mangyaring mag-sign out at mag-sign in muli, pagkatapos subukan ulit.',
    adminLocalization: 'Admin: Lokalisasyon',
    // Guest User Messages
    notSignedIn: 'Hindi naka-sign in',
    guestNoAccount: 'Naglalaro ka bilang bisita. Mag-sign in para lumikha ng account at i-save ang iyong progress.',
    ok: 'OK',
    pgsTitle: 'Play Games',
    pgsConnect: 'Ikonekta ang Play Games',
    pgsConnecting: 'Kumokonekta...',
    pgsAchievements: 'Mga Achievement sa Play Games',
    pgsConnectFailed: 'Hindi makakonekta sa Play Games. Pakisubukan muli.',
    pgsConnectSuccess: 'Matagumpay na nakakonekta sa Google Play Games.',
    pgsLinkFailed: 'Hindi na-link ang account. Pakisubukan muli.',
    pgsError: 'May nangyaring error. Pakisubukan muli.',
  },
  it: {
    title: 'Impostazioni',
    subtitle: 'Personalizza la tua esperienza di quiz biblico',
    account: 'Account',
    notifications: 'Notifiche',
    sound: 'Suono',
    darkMode: 'Modalità scura',
    language: 'Lingua',
    fontSize: 'Dimensione carattere',
    decreaseFont: 'Diminuisci dimensione carattere',
    increaseFont: 'Aumenta dimensione carattere',
    help: 'Aiuto',
    privacyPolicy: 'Informativa sulla privacy',
    termsOfService: 'Termini di servizio',
    about: 'Informazioni',
    subscription: 'Abbonamento',
    premium: 'Premium',
    managePremium: 'Visualizza i piani e gestisci il tuo abbonamento',
    signOut: 'Esci',
    signingOut: 'Disconnessione in corso...',
    endSession: 'Termina la sessione corrente',
    signOutFailed: 'Logout fallito',
    // Account Management
    accountManagement: 'Account',
    resetPasswordTitle: 'Reimposta password',
    resetPasswordDetail: 'Invia un link di reimpostazione alla tua email',
    resetPasswordMessage: 'Invieremo un link per reimpostare la password a {email}',
    sendResetLink: 'Invia link di reimpostazione',
    resetPasswordSent: 'Email inviata',
    resetPasswordSentMessage: 'Controlla la tua casella di posta su {email} per il link di reimpostazione della password.',
    resetPasswordFailed: 'Invio dell\'email di reimpostazione fallito. Riprova.',
    oauthNoPassword: 'Hai effettuato l\'accesso con {provider}. Nessuna password da reimpostare — accedi semplicemente con il tuo account {provider}.',
    signedInWith: 'Accesso effettuato con {provider}',
    noEmailFound: 'Nessun indirizzo email trovato per questo account.',
    error: 'Errore',
    deletingAccount: 'Eliminazione...',
    deleteConfirmTitle: 'Sei sicuro?',
    deleteConfirmMessage: 'Il tuo account {provider} ({email}) e tutti i dati del quiz verranno eliminati permanentemente.',
    deleteConfirmButton: 'Sì, elimina tutto',
    reAuthRequired: 'Verifica identità',
    reAuthMessage: 'Disconnettiti e accedi di nuovo, poi riprova.',
    adminLocalization: 'Admin: Localizzazione',
    // Guest User Messages
    notSignedIn: 'Non connesso',
    guestNoAccount: 'Stai giocando come ospite. Accedi per creare un account e salvare i tuoi progressi.',
    ok: 'OK',
    pgsTitle: 'Play Games',
    pgsConnect: 'Collega Play Games',
    pgsConnecting: 'Connessione...',
    pgsAchievements: 'Obiettivi Play Games',
    pgsConnectFailed: 'Impossibile connettersi a Play Games. Riprova.',
    pgsConnectSuccess: 'Connessione a Google Play Games riuscita.',
    pgsLinkFailed: 'Impossibile collegare l\'account. Riprova.',
    pgsError: 'Si è verificato un errore. Riprova.',
  },
  am: {
    title: 'ቅንብሮች',
    subtitle: 'የመፅሐፍ ቅድስ ግንዛኔዎን ያስተካከሉ',
    account: 'መለያ',
    notifications: 'ማሳወቂያዎች',
    sound: 'ድምፅ',
    darkMode: 'ጨለማ ሁኔታ',
    language: 'ቋንቋ',
    fontSize: 'የቅርጸ-ቁምፊ መጠን',
    decreaseFont: 'የቅርጸ-ቁምፊ መጠን ቀንስ',
    increaseFont: 'የቅርጸ-ቁምፊ መጠን ጨምር',
    help: 'እርዳታ',
    privacyPolicy: 'የግላዊነት ፖሊሲ',
    termsOfService: 'የአገልግሎት ውሎች',
    about: 'ስለ',
    subscription: 'ምዝገባ',
    premium: 'ፕሪሚየም',
    managePremium: 'ዕቅዶችን ይመልከቱ እና ምዝገባዎን ያስተዳድሩ',
    signOut: 'ውጣ',
    signingOut: 'በመውጣት ላይ...',
    endSession: 'የአሁኑን ክፍለ ጊዜ ያጠናቅቁ',
    signOutFailed: 'መውጣት አልተሳካም',
    // Account Management
    accountManagement: 'መለያ',
    resetPasswordTitle: 'የይለፍ ቃል ዳግም አስጀምር',
    resetPasswordDetail: 'ወደ ኢሜልዎ የዳግም ማስጀመሪያ ማገናኛ ይላኩ',
    resetPasswordMessage: 'ወደ {email} የይለፍ ቃል ዳግም ማስጀመሪያ ማገናኛ እንልካለን',
    sendResetLink: 'የዳግም ማስጀመሪያ ማገናኛ ላክ',
    resetPasswordSent: 'ኢሜል ተልኳል',
    resetPasswordSentMessage: 'የይለፍ ቃል ዳግም ማስጀመሪያ ማገናኛ ለማግኘት በ {email} የገቢ መልዕክት ሳጥንዎን ይመልከቱ።',
    resetPasswordFailed: 'የዳግም ማስጀመሪያ ኢሜል መላክ አልተሳካም። እባክዎ እንደገና ይሞክሩ።',
    oauthNoPassword: 'በ {provider} ገብተዋል። የሚዳግም የይለፍ ቃል የለም — በ {provider} መለያዎ ብቻ ይግቡ።',
    signedInWith: 'በ {provider} ገብቷል',
    noEmailFound: 'ለዚህ መለያ ኢሜል አድራሻ አልተገኘም።',
    error: 'ስህተት',
    deletingAccount: 'በመሰረዝ ላይ...',
    deleteConfirmTitle: 'እርግጠኛ ነዎት?',
    deleteConfirmMessage: 'የ {provider} መለያዎ ({email}) እና ሁሉም የፈተና ውሂብ በቋሚነት ይሰረዛሉ።',
    deleteConfirmButton: 'አዎ፣ ሁሉንም ሰርዝ',
    reAuthRequired: 'ማንነትን ያረጋግጡ',
    reAuthMessage: 'እባክዎ ውጡና እንደገና ይግቡ፣ ከዚያ እንደገና ይሞክሩ።',
    adminLocalization: 'አድሚን: አካባቢያዊንግ',
    // Guest User Messages
    notSignedIn: 'ገብተው አይደሉም',
    guestNoAccount: 'እንግዳ ሆነው እየተጫወቱ ነው። መለያ ለመፍጠር እና እድገትዎን ለማስቀመጥ ይግቡ።',
    ok: 'እሺ',
    pgsTitle: 'ፕሌይ ጌምስ',
    pgsConnect: 'ፕሌይ ጌምስን አገናኝ',
    pgsConnecting: 'በመገናኘት ላይ...',
    pgsAchievements: 'የፕሌይ ጌምስ ስኬቶች',
    pgsConnectFailed: 'ወደ ፕሌይ ጌምስ መገናኘት አልተቻለም። እባክዎ እንደገና ይሞክሩ።',
    pgsConnectSuccess: 'ከጉግል ፕሌይ ጌምስ ጋር በተሳካ ሁኔታ ተገናኝቷል።',
    pgsLinkFailed: 'መለያውን ማገናኘት አልተቻለም። እባክዎ እንደገና ይሞክሩ።',
    pgsError: 'ስህተት ተፈጥሯል። እባክዎ እንደገና ይሞክሩ።',
  },
  ko: {
    title: '설정',
    subtitle: '성경 퀴즈 경험을 사용자 지정',
    account: '계정',
    notifications: '알림',
    sound: '소리',
    darkMode: '다크 모드',
    language: '언어',
    fontSize: '글꼴 크기',
    decreaseFont: '글꼴 크기 줄이기',
    increaseFont: '글꼴 크기 늘리기',
    help: '도움말',
    privacyPolicy: '개인정보 보호정책',
    termsOfService: '서비스 약관',
    about: '정보',
    subscription: '구독',
    premium: '프리미엄',
    managePremium: '요금제를 확인하고 구독을 관리하세요',
    signOut: '로그아웃',
    signingOut: '로그아웃 중...',
    endSession: '현재 세션 종료',
    signOutFailed: '로그아웃 실패',
    // Account Management
    accountManagement: '계정',
    resetPasswordTitle: '비밀번호 재설정',
    resetPasswordDetail: '이메일로 재설정 링크 보내기',
    resetPasswordMessage: '{email}로 비밀번호 재설정 링크를 보내드리겠습니다',
    sendResetLink: '재설정 링크 보내기',
    resetPasswordSent: '이메일 전송됨',
    resetPasswordSentMessage: '{email} 받은편지함에서 비밀번호 재설정 링크를 확인하세요.',
    resetPasswordFailed: '재설정 이메일 전송에 실패했습니다. 다시 시도하세요.',
    oauthNoPassword: '{provider}로 로그인하셨습니다. 재설정할 비밀번호가 없습니다 — {provider} 계정으로 로그인하세요.',
    signedInWith: '{provider}로 로그인됨',
    noEmailFound: '이 계정에 연결된 이메일 주소를 찾을 수 없습니다.',
    error: '오류',
    deletingAccount: '삭제 중...',
    deleteConfirmTitle: '정말 삭제하시겠습니까?',
    deleteConfirmMessage: '{provider} 계정({email})과 모든 퀴즈 데이터가 영구적으로 삭제됩니다.',
    deleteConfirmButton: '네, 모두 삭제',
    reAuthRequired: '본인 확인',
    reAuthMessage: '로그아웃 후 다시 로그인한 다음 다시 시도하세요.',
    adminLocalization: '관리자: 현지화',
    // Guest User Messages
    notSignedIn: '로그인하지 않음',
    guestNoAccount: '게스트로 플레이 중입니다. 로그인하여 계정을 만들고 진행 상황을 저장하세요.',
    ok: '확인',
    pgsTitle: 'Play Games',
    pgsConnect: 'Play Games 연결',
    pgsConnecting: '연결 중...',
    pgsAchievements: 'Play Games 업적',
    pgsConnectFailed: 'Play Games에 연결할 수 없습니다. 다시 시도하세요.',
    pgsConnectSuccess: 'Google Play Games에 성공적으로 연결되었습니다.',
    pgsLinkFailed: '계정을 연결하지 못했습니다. 다시 시도하세요.',
    pgsError: '오류가 발생했습니다. 다시 시도하세요.',
  },
};
